'use client';
import { Card } from './card.js';
import { CardBlock } from './card-block.js';

/**
 * Card component to present content in a structured way.
 *
 * @example
 * <Card>
 *  <Card.Block>Header</Card.Block>
 *  <Card.Block>Content</Card.Block>
 *  <Card.Block>Footer</Card.Block>
 * </Card>
 */
const CardComponent = Object.assign(Card, {
    Block: CardBlock,
});
CardComponent.Block.displayName = 'Card.Block';

export { CardComponent as Card, CardBlock };
